import * as React from "react";
const SvgFiRrBread = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bread_svg__a)">
      <path
        fill="#062147"
        d="M6.028 24c-4.98-.021-7.075-4.188-5.535-9.179C2.343 7.43 15.015-4.362 22.359 1.641 28.834 9.569 14.584 24.3 6.028 24m11.94-22C11.4 2.25 4.239 9.3 2.412 15.384c-.721 2.451-.492 4.426.644 5.561 6.8 5.332 23.222-11.089 17.89-17.89A4.07 4.07 0 0 0 17.969 2M15 14a4.785 4.785 0 0 0-5-5 1 1 0 0 0 0 2 2.784 2.784 0 0 1 3 3 1 1 0 1 0 2 0m4-4a4.785 4.785 0 0 0-5-5 1 1 0 1 0 0 2 2.783 2.783 0 0 1 3 3 1 1 0 1 0 2 0m-8 8a4.785 4.785 0 0 0-5-5 1 1 0 1 0 0 2 2.784 2.784 0 0 1 3 3 1 1 0 1 0 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bread_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBread;
